import { createAction } from '@reduxjs/toolkit';

const descriptionGenerationStarted = createAction('asset/descriptionGenerationStarted', (assetsIds) => {
  return {
    payload: { assetsIds },
  };
});
export default descriptionGenerationStarted;
